import { Grid, LinearProgress, Switch, Tooltip, Typography } from "@mui/material";
import { useEffect } from "react";
import { TwoFactorStyles } from "src/components/settings/profile/styles/TwoFactor.styles";
import { trackEvent } from "src/Amplitude";
import api from "src/store/features/api";
import { useAccountLockForm } from "./useAccountLock";
import AccountLockModal from "./AccountLockModal";
import { toggleAccountLockModal, useAccountLockState } from "./accountLock.slice";
import { useDispatch } from "react-redux";

export function AccountLock() {
  const classes = TwoFactorStyles();
  const label = { inputProps: { "aria-label": "Enabled" } };
  const dispatch = useDispatch();

  const { isLoadingLockAccount } = useAccountLockForm();
  const { isAccountLockModalOpen } = useAccountLockState();

  // ----------------- API -----------------
  const {
    data: user,
    isSuccess,
    isFetching: isFetchingUser,
    refetch,
  } = api.useGetUserDatav2Query();
  const { accountLock } = isSuccess
    ? user
    : { accountLock: { locked: false, lockType: null, reason: null, timestamp: null } };

  const isLoading = isLoadingLockAccount || isFetchingUser;

  // ----------------- HANDLERS -----------------
  const handleClick = async (event: any) => {
    trackEvent(
      "Button_Click",
      {
        button: "Account_Lock_Switch",
      },
      "Account_Lock",
    );
    if (event.target.checked) {
      dispatch(toggleAccountLockModal());
    }
  };

  // ----------------- USE EFFECTS -----------------
  useEffect(() => {
    if (!isAccountLockModalOpen) {
      refetch();
    }
  }, [isAccountLockModalOpen]);

  // ----------------- DESIGN -----------------
  return (
    <>
      <AccountLockModal />
      <Grid container alignItems="center" className={classes.container}>
        {isLoading && (
          <Grid item xs={12}>
            <LinearProgress sx={{ paddingLeft: "10px", paddingRight: "10px" }} />
          </Grid>
        )}

        <Grid item xs={12}>
          <Typography className={classes.heading}>Lock account</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            Locking your account will limit the following actions on your account: withdrawing,
            depositing, trading.
          </Typography>
        </Grid>

        <Grid item xs={4} className={classes.switch}>
          <Tooltip
            title={
              accountLock?.locked
                ? "To unlock your account, please contact us at support@calebandbrown.com"
                : "Click to lock your account"
            }>
            <Switch
              {...label}
              checked={accountLock?.locked}
              onClick={handleClick}
              disabled={isLoading}
            />
          </Tooltip>
        </Grid>

        {accountLock?.locked && accountLock?.timestamp && (
          <Grid item xs={12}>
            <Typography sx={{ color: "#EF4444" }}>
              Account locked on: {new Date(accountLock?.timestamp).toLocaleString()}
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
}
